/* **************************************************** Quotation note */
export interface QuotationNote {
    id: number;
    note: string;
    status: 1 | 0;
}

export const mapQuotationNote = (data: any): QuotationNote => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: QuotationNote = {
        id: data.id,
        note: data.note,
        status: data.status,
    };

    return res;
};

export const mapQuotationNotes = (data: any[]): QuotationNote[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapQuotationNote);
};
/* **************************************************** */